var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('event-tabs',{attrs:{"event-data":_vm.eventData,"event-template-type-id":_vm.EVENT_TEMPLATE_TYPE_CONFIGURATION,"template-form-label":_vm.$t('COMMUNICATION_RULE'),"loading":_vm.loading},on:{"saved":_vm.getData}})}
var staticRenderFns = []

export { render, staticRenderFns }